import { render, staticRenderFns } from "./DuelsUserElement.vue?vue&type=template&id=cbb11a64&scoped=true"
import script from "./DuelsUserElement.vue?vue&type=script&lang=js"
export * from "./DuelsUserElement.vue?vue&type=script&lang=js"
import style0 from "./DuelsUserElement.vue?vue&type=style&index=0&id=cbb11a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb11a64",
  null
  
)

export default component.exports